import React, { useState, useEffect } from 'react';
import { Input, Checkbox, Row, Col } from 'antd';

const Addon = ({ name, ruleId, index, value = {}, onChange, isEdit }) => {
  const [isDisabled, setDisabled] = useState(false);
  const [rule, setId] = useState(null);
  const triggerChange = (changedValue) => {
    if (onChange) {
      onChange({
        rule,
        isDisabled,
        ...value,
        ...changedValue,
      });
    }
  };

  useEffect(() => {
    if(isEdit) setDisabled(value.isDisabled);
  }, []);
  useEffect(() => {
    setRuleId();
  }, [ruleId]);

  const setRuleId = () => {
    setId({
      id: ruleId,
    });
    triggerChange({
      rules: {
        id: ruleId,
      },
    });
  };
  const setAvailability = (checked) => {
    setDisabled(checked);
    triggerChange({ isDisabled: checked });
  };
  const changeDisplayName = (name) => {
    return `${name.split(" ")[0]} ${name.split(" ")[1]}`
  }
  return (
    <>
      <div key={index}>
        <Row>
          <Col offset={8}/>
          <Col span={16}>
            <Checkbox onChange={(e) => setAvailability(e.target.checked)} checked={isDisabled}>{name}</Checkbox>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Addon;
